export interface SearchableAnswer { id: string; title: string; topic: string; command: string; tags: string[]; prose: string[] }
export function keywordScore(answer: SearchableAnswer, query: string) {
  const normalized = query.trim().toLowerCase()
  if (!normalized) return 0
  const text = `${answer.title} ${answer.topic} ${answer.command} ${answer.tags.join(' ')} ${answer.prose.join(' ')}`.toLowerCase()
  if (!text.includes(normalized)) return 0
  return answer.title.toLowerCase().includes(normalized) ? 3 : 2
}
export function searchScore(answer: SearchableAnswer, query: string, semantic: Map<string, number>) {
  return keywordScore(answer, query) + (semantic.get(answer.id) ?? 0)
}
